import { render, staticRenderFns } from "./DetailLocation.vue?vue&type=template&id=51ce10dc"
import script from "./DetailLocation.vue?vue&type=script&lang=js"
export * from "./DetailLocation.vue?vue&type=script&lang=js"
import style0 from "./DetailLocation.vue?vue&type=style&index=0&id=51ce10dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports